import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';

export default function SourceIps() {

  const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';
  const imgRoute = 'images/analytics/sourceIps.png';
  const route = baseRoute + imgRoute;

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        Source IPs
      </Typography>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
      <img 
          alt="Cve Info"
          src={route}
          width="95%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginBottom: '-70px'  }}
      />
      </Box>
    </Container>
  );
};
